import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
// eslint-disable-next-line import/no-cycle
import { useRouter } from 'next/router';
// eslint-disable-next-line import/no-cycle
import Mobile from '@/components/Device/Mobile';
import ToastLoading from '@/components/ToastLoading';
import Reset from '@/components/Icon/Reset';
import MenuItem from './MenuItem';
import { findMenusByString } from '../../utils';
// eslint-disable-next-line import/no-cycle
import ResourceContext, { Tag } from '../../context';
import { RootMenu } from '../../types';

// const getInitOpenMenuKeys = (currentMenus: LeftMenu[], data: RootMenu[]) => {
//   const initOpenMenuKeys: string[] = [];
//   if (currentMenus?.length > 1) {
//     const length1 = currentMenus.length - 1;
//     const length2 = currentMenus.length - 2;
//     initOpenMenuKeys.push(currentMenus[length1].parentValue as string);
//     initOpenMenuKeys.push(currentMenus[length2].parentValue as string);
//   }
//   if (currentMenus?.length === 1) {
//     initOpenMenuKeys.push(currentMenus[0].parentValue as string);
//   }

//   return initOpenMenuKeys?.length ? initOpenMenuKeys : [data[0].value];
// };

interface Props {
  handleClose?: () => void;
  data: RootMenu[];
  visible?: boolean;
}

const Menu: FC<Props> = ({ handleClose, data, visible }) => {
  const { t } = useTranslation('resources');
  const router = useRouter();
  const { tags } = router.query;
  const currentMenus = findMenusByString(tags as string, data);
  const [mobileTags, setMobileTags] = useState<Tag[]>([]);
  const { setFilterTagsAndUpdatePath } = useContext(ResourceContext);
  // const initOpenMenuKeys = getInitOpenMenuKeys(currentMenus, data);
  const initOpenMenuKeys = data?.map?.(({ value }) => value) || [];
  const [openMenuKeys, setOpenMenuKeys] = useState<string[]>(initOpenMenuKeys);
  // const showBanner = useShowBanner();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (visible) {
      setMobileTags(currentMenus as Tag[]);
    }
    if (visible === false) {
      timer = setTimeout(() => {
        setMobileTags([]);
      }, 300);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [visible]);

  const changeOpen = (key: string) => {
    if (openMenuKeys?.includes(key)) {
      setOpenMenuKeys(openMenuKeys.filter((item) => item !== key));
      return;
    }

    /** 只能展开2个逻辑 */
    // if (openMenuKeys.length > 0) {
    //   setOpenMenuKeys([openMenuKeys?.[0], key]);
    //   return;
    // }

    /** 可以展开全部逻辑 */
    if (openMenuKeys.length > 0) {
      setOpenMenuKeys([...openMenuKeys, key]);
      return;
    }

    setOpenMenuKeys([key]);
  };

  const pushMobileTag = (tag: Tag) => {
    const tagList = mobileTags.filter((item) => item.parentValue !== tag.parentValue);
    const currentTags = [...tagList, tag];
    setMobileTags(currentTags);
  };

  const deleteMobileTag = (tag: Tag) => {
    const currentTags = mobileTags.filter((item) => item.value !== tag.value);
    setMobileTags(currentTags);
  };

  return (
    <div className="lg:w-[184px] xl:w-[214px] mobile:w-full mobile:pt-[16px]  pc:mr-[24px]">
      {/* {showBanner && (
        <PC>
          <BannerPC />
        </PC>
      )} */}
      <ul className="mobile:h-[calc(100vh_-_160px)] mobile:overflow-y-auto mobile:px-[16px]">
        {data.map((item) => (
          <MenuItem
            {...item}
            key={item.value}
            mobileTags={mobileTags}
            pushMobileTag={pushMobileTag}
            deleteMobileTag={deleteMobileTag}
            openMenuKeys={openMenuKeys}
            changeOpen={changeOpen}
          />
        ))}
      </ul>
      <Mobile>
        <div className="box-border h-[80px] border-t-[1px] border-solid border-[#DFE0ED] px-[16px] pt-[12px]">
          <div className="flex items-center justify-between">
            <Reset onClick={() => setMobileTags([] as Tag[])} />
            <button
              onClick={() => {
                ToastLoading.show(window.location.href.includes('/zh/') ? '加载中...' : 'loading...');
                setFilterTagsAndUpdatePath(mobileTags);
                handleClose?.();
              }}
              type="button"
              className="flex h-[40px] items-center rounded-[20px] border-[1px] border-solid border-[#DFE0ED] bg-white px-[28px] text-[16px] text-[#1B1F4D]"
            >
              {t('确定')}
            </button>
          </div>
        </div>
      </Mobile>
    </div>
  );
};

export default Menu;
